var petImages = {
    DUCK: "https://i.imgur.com/SKO1ERz.png",
    GORRILA: "https://i.imgur.com/q9DujeZ.png",
    ELEPHANT: "https://i.imgur.com/VdM0Fdm.png",
    FROG: "https://i.imgur.com/1rp0oEN.png",
    HP8: "https://i.imgur.com/VDhWbqe.png",
    PANDA: "https://i.imgur.com/NSXWgqM.png",
    PENGUIN: "https://i.imgur.com/kbnul85.png",
    SHIBE: "https://i.imgur.com/abmvlLq.png",
    SLOTH: "https://i.imgur.com/QUI0Iwt.png",
    WHITE_PUG: "https://i.imgur.com/veu7OWm.png",
    HEROBRINE: "https://i.imgur.com/MXOr7so.png",
    
    IRON_GOLEM: "https://i.imgur.com/kCCRhJ2.png",
    COW: "https://i.imgur.com/oHEkDqq.png",
    SHEEP: "https://i.imgur.com/3UloGVy.png",
    PIG: "https://i.imgur.com/UMakvFn.png",
    PIG_ZOMBIE: "https://i.imgur.com/3UloGVy.png",
    WOLF: "https://i.imgur.com/761JmjR.png",
    CREEPER_POWERED: "https://i.imgur.com/aNQXmTV.png",
    CREEPER: "https://i.imgur.com/aNQXmTV.png",
    SNOWMAN: "https://i.imgur.com/nugM13G.png",
    VILLAGER: "https://i.imgur.com/clNa72Q.png",
    ZOMBIE: "https://i.imgur.com/OMwD8Kz.png",
    DONKEY: "https://i.imgur.com/vUuosgU.png",
    HORSE: "https://i.imgur.com/yoX8yYL.png",
    SQUID: "https://i.imgur.com/8DeEejS.png",
    WITCH: "https://i.imgur.com/Eqbq9gs.png",
    WILD_OCELOT: "https://i.imgur.com/zaQ1rQO.png",
    CHICKEN: "https://i.imgur.com/TmhD75n.png",
    SLIME: "https://i.imgur.com/k1MY7R5.png",
    MAGMA_CUBE: "https://i.imgur.com/jOzpa1o.png",
    SILVERFISH: "https://i.imgur.com/oa8m4wR.png",
    BLAZE: "https://i.imgur.com/8lL49AL.png",
    MOOSHROOM: "https://i.imgur.com/0yd6GcW.png",
    SKELETON: "https://i.imgur.com/OfENqPw.png",
    SPIDER: "https://i.imgur.com/3EDSmjA.png",
    CAVE_SPIDER: "https://i.imgur.com/eQhszph.png",
    MULE: "https://i.imgur.com/sFrBQhi.png",
    ENDERMAN: "https://i.imgur.com/5LCSvYD.png",
    BAT: "https://i.imgur.com/0OVbiRM.png"
}

exports.getImage = function(name) {
    if(name.indexOf("SHEEP") > -1) {
        return petImages["SHEEP"];
    } else if(name.indexOf("HORSE") > -1) {
        return petImages["HORSE"];
    } else if(name.indexOf("CAT") > -1) {
        return petImages["WILD_OCELOT"];
    } else if(name.indexOf("SLIME") > -1) {
        return petImages["SLIME"]
    } else if(name.indexOf("MAGMA_CUBE") > -1) {
        return petImages["MAGMA_CUBE"]        
    } else if(name.indexOf("VILLAGER") > -1) {
        return petImages["VILLAGER"]
    } else if(name.indexOf("BABY") > -1) {
        return petImages[name.replace("_BABY", "")]
    } else {
        if ($.inArray(name, Object.keys(petImages)) !== -1){
            return petImages[name];
        } else {
            return "https://i.imgur.com/NqroVsl.png"
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/images.js
 **/